module Shared {
    export class JobTitle {
        titleText: string;
        failsSdc: boolean;
    }
}